import { Product } from "@/interfaces";
import { ProductRow } from "../../../components";
import * as S from "./styles";

export type ProductTableProps = {
  items?: Product[];
  defaultProductImageUrl?: string;
  coopEligible?: number;
  onItemClick?: (item: Product) => void;
};

const ProductTable: React.FC<ProductTableProps> = ({
  items = undefined,
  defaultProductImageUrl = undefined,
  coopEligible = undefined,
  onItemClick,
}) => {
  return Array.isArray(items) && items?.length ? (
    <S.ProductTableContainer>
      <ProductRow
        items={items}
        defaultProductImageUrl={defaultProductImageUrl}
        coopEligible={coopEligible}
        onItemClick={onItemClick}
      />
    </S.ProductTableContainer>
  ) : (
    <S.ProductTableNoDataMessageContainer>
      <S.ProductTableNoDataMessage>
        There is no data
      </S.ProductTableNoDataMessage>
    </S.ProductTableNoDataMessageContainer>
  );
};

export default ProductTable;
